import { Typography } from '@mui/material';
import i18next from 'i18next';
import { memo, useCallback } from 'react';

import {
  MultiStoreBusyCenter,
  MultiStoreCenterDay,
} from '../../../../interface/multi-store';
import { MultiStoreCardFrame } from './multi-store-card-frame';
import { MultiStoreCenterContent } from './multi-store-center-content';
import { MultiStoreHourChip } from './multi-store-hour-chip';

interface MultiStoreBusyCardProps {
  busy: MultiStoreBusyCenter;
  hour: string;
  // giorno scelto per esteso, per «Nessun orario …»
  dayLabel: string;
  onSwitch: (center: MultiStoreCenterDay, hour: string) => void;
}

// Centro non libero all'orario scelto: scheda statica (niente action, così il tocco su un
// chip non risale alla scheda) con gli orari più vicini, che cambiano centro e ora. Il
// riquadro non rimonta i chip quando il calendario si ridisegna: il focus resta su di loro.
export const MultiStoreBusyCard = memo(function MultiStoreBusyCard({
  busy: { center, nearHours },
  hour,
  dayLabel,
  onSwitch,
}: MultiStoreBusyCardProps): JSX.Element {
  const handleNearHour = useCallback(
    (nearHour: string) => {
      onSwitch(center, nearHour);
    },
    [center, onSwitch]
  );

  return (
    <div className="multi-store-static-card">
      <MultiStoreCardFrame>
        <MultiStoreCenterContent
          pointOfSale={center.pointOfSale}
          isOrigin={center.isOrigin}
          distance={center.distance}
          isAddressVisible={false}
        >
          {nearHours.length > 0 ? (
            <>
              <Typography variant="contentDescription2">
                {i18next.t('pages.when.multi_store.busy_at', { hour })}
              </Typography>
              <div className="multi-store-near-hours">
                {nearHours.map((nearHour) => (
                  <MultiStoreHourChip
                    key={nearHour.hour}
                    hour={nearHour.hour}
                    onSelect={handleNearHour}
                  />
                ))}
              </div>
            </>
          ) : (
            <Typography variant="contentDescription2">
              {i18next.t('pages.when.multi_store.no_hours', { day: dayLabel })}
            </Typography>
          )}
        </MultiStoreCenterContent>
      </MultiStoreCardFrame>
    </div>
  );
});
